export default function WhatsAppButton() {
  const handleClick = () => {
    window.open('https://wa.me/34628752701?text=Hola,%20me%20gustaría%20solicitar%20información%20sobre%20sus%20servicios', '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-30 flex items-center justify-center w-14 h-14 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 cursor-pointer animate-pulse-slow"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </button>
  );
}